<div class="date-container">
    <div class="date-header">
        <h4>Sales Orders Today</h4>
        <p class="date-display">{{ getFormattedDate() }}</p>
    </div>
    <div class="summary-info">
        <div class="summary-line">
            <div class="line-label">Total Sales:</div>
            <div>{{ totalSales | currency }}</div>
        </div>
        <div class="summary-line">
            <div class="line-label">Total Orders:</div>
            <div>{{ totalOrders }}</div>
        </div>
        <div class="summary-line">
            <div class="line-label">Average Order Value:</div>
            <div>{{ averageOrderValue | currency }}</div>
        </div>
    </div>    
    
    <!-- Different format examples -->
    <!-- <div class="date-formats">
      <p><strong>Short:</strong> {{ currentDate | date:'short' }}</p>
      <p><strong>Medium:</strong> {{ currentDate | date:'medium' }}</p>
      <p><strong>Long:</strong> {{ currentDate | date:'fullDate' }}</p>
      <p><strong>Custom:</strong> {{ currentDate | date:'EEEE, MMMM d, y' }}</p>
      <p><strong>ISO:</strong> {{ currentDate | date:'yyyy-MM-dd' }}</p>
    </div> -->
  </div>
